/**
 * Homepage profile section — decorative ellipses enter on scroll (Intersection Observer).
 * Respects prefers-reduced-motion.
 */

const REDUCED_MOTION_MQ = '(prefers-reduced-motion: reduce)';
const DECO_SELECTOR = '.header__deco-elipse';
const CONTAINER_SELECTOR = '.header__frontalier-type-btn-container';

function initHeaderDecoEnter() {
	const container = document.querySelector(CONTAINER_SELECTOR);
	if (!container) {
		return;
	}

	const decos = container.querySelectorAll(DECO_SELECTOR);
	if (!decos.length) {
		return;
	}

	if (window.matchMedia(REDUCED_MOTION_MQ).matches) {
		decos.forEach((el) => el.classList.add('is-visible'));
		return;
	}

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}
				entry.target.classList.add('is-visible');
				observer.unobserve(entry.target);
			});
		},
		{
			threshold: 0.2,
			rootMargin: '0px 0px -2% 0px',
		},
	);

	decos.forEach((el) => observer.observe(el));
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initHeaderDecoEnter);
} else {
	initHeaderDecoEnter();
}
